import { QueryClient, type QueryKey } from '@tanstack/react-query';
import { processResponse, Queries } from '../query-client';
import type { WidgetConfig } from '../../store/widget.store';

function GetShopInfo() {
    return fetch(`/api/admin/shop/info`, {
        method: 'get',
    }).then(processResponse<WidgetConfig[]>);
}

export function addShopQueries(queryClient: QueryClient) {
    queryClient.setQueryDefaults([Queries.SHOP_GET_INFO], {
        queryFn: GetShopInfo,
    });
}
